<template>
    <div class="checkbox-content" :class="variant">
      <label class="checkbox-container" :for="props.id" :title="tooltip">
        <input 
            type="checkbox" 
            :id="id" 
            :checked="modelValue" 
            @change="$emit('update:modelValue', $event.target.checked)"
            ref="checkbox"
        />
        <div class="checkmark" :class="variant"></div>
      </label>
      <div>
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script setup>
  import { defineProps, computed } from 'vue';
  
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "green"
    },
    id: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: ''
    }
  });  
  const variant = computed(() => ({
    [`checkbox-variant-${props.variant}`]: true
  }));
  </script>
  
  <style>
  .checkbox-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .checkbox-container input {
    position: absolute;
    z-index: 1;
    opacity: 0.01;
    cursor: pointer;
  }
  .checkbox-container {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 20px;
    user-select: none;
  }
  .checkmark {
    position: relative;
    height: 16px;
    width: 16px;
    background: transparent;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.30), 0px 1px 1px rgba(0,5);
    border: 1px solid #CDCED9;
  }
  .checkbox-variant-green input:checked ~ .checkbox-variant-green {
    background-color: #007A5E;
  }
  .checkbox-variant-green.checkked {
    background-color: #007A5E;
  }
  .checkbox-variant-black input:checked ~ .checkbox-variant-black {
    background-color: #272833;
  }
  .checkbox-variant-black.checkked {
    background-color: #272833;
  }
  .checkbox-variant-gray input:checked ~ .checkbox-variant-gray {
    background-color: #6B6C7E;
  }
  .checkbox-variant-gray.checkked {
    background-color: #6B6C7E;
  }
  .checkbox-variant-yellow input:checked ~ .checkbox-variant-yellow {
    background-color: #FAB427;
  }
  .checkbox-variant-yellow.checkked {
    background-color: #FAB427;
  }
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  .checkbox-container .checkmark:after {
    left: 4px;
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 0.15em 0.15em 0;
    transform: rotate(45deg);
    border-radius: 4px;
  }
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }
  </style>